export default __webpack_public_path__ + "static/media/178f5691f8569a414739efb7b730bc7f.svg";